import { useMediaQuery } from '@mui/material'
import { breakpoints } from './breakpoints.js'
import { type ThemeDeviceProps } from './device-props.js'

declare global {
  interface Window {
    // TODO: fix leaning on Cypress in shared code
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Cypress: any
  }
}

export function useDeviceDetect(): ThemeDeviceProps {
  const mobileQuery = `${breakpoints.down('md')}`
  const desktopQuery = `${breakpoints.up('md')}`

  const isMobile = useMediaQuery(`${mobileQuery}${!window.Cypress ? ', not all and (pointer: fine)' : ''}`, {
    noSsr: true,
  })
  const isDesktop = !isMobile

  return { isMobile, isDesktop, mobileQuery, desktopQuery }
}
